let id = 0

function uuid() {
    return ++id
}

const menu = [
    {
        id: uuid(),
        name: '控制台',
        url: null,
        icon: 'dashboard',
        children: [
            {
                id: uuid(), name: '首页',  url: 'home', icon: null
            }
        ]
    },
]

export default menu
